export default {
  validate(oForm, aRules, aMessages) {
    let validator = null;

    if (oForm.length > 0) {
      let errorContainer = $(".alert-danger", oForm);

      // jQuery Validate Docs: http://docs.jquery.com/Plugins/Validation
      validator = oForm.validate({
        debug: false,
        errorElement: "span", //default input error message container
        errorClass: "help-block help-block-error", // default input error message class
        focusInvalid: false, // do not focus the last invalid input
        ignore:
          ".select2-input, .select2-search__field, .no-validate, .note-editor *", // validate all fields including form hidden input
        rules: aRules,
        messages: aMessages,

        invalidHandler(event, validator) {
          errorContainer.show();
          App.scrollTo(errorContainer, -200);
        },

        errorPlacement(error, element) {
          let icon = $(element)
            .parent(".input-icon")
            .children("i");
          //let icon = $(element).parent('.input-icon').find('[data-fa-processed]');
          icon.removeClass("fa-check").addClass("fa-exclamation-triangle");
          icon
            .attr("data-original-title", error.text())
            .tooltip({container: "body"});
        },

        highlight(element) {
          $(element)
            .closest(".form-group")
            .removeClass("has-success")
            .addClass("has-error");
        },

        unhighlight(element) {
        },

        success(label, element) {
          let icon = $(element)
            .parent(".input-icon")
            .children("i");
          //let icon = $(element).parent('.input-icon').find('[data-fa-processed]');
          $(element)
            .closest(".form-group")
            .removeClass("has-error")
            .addClass("has-success");
          icon.removeClass("fa-exclamation-triangle").addClass("fa-check");
        },

        submitHandler(form) {
          errorContainer.hide();
          form.submit();
        }
      });
    }

    return validator;
  },

  clearValidation(form) {
    let validator = $(form).validate();
    // Itera sobre los elementos con nombre asignado dentro del formulario
    $("[name]", form).each(function () {
      // Remueve la clase de validación del contenedor padre
      $(this)
        .closest(".form-group")
        .removeClass("has-error has-success");

      // Remueve el icono y su tooltip
      let icon = $(this)
        .parent(".input-icon")
        .children("i");
      icon.removeClass("fa-exclamation-triangle fa-check");
      icon.data("original-title", null);

      //validator.successList.push(this);//mark as error free
      //validator.showErrors(); //remove error messages if present
    });

    validator.resetForm();
    validator.reset();

    return validator;
  },

  handleSearch() {
    const self = this;
    // Realiza la búsqueda
    $("#btn-buscar").click(function (e) {
      e.preventDefault();
      // Indicador de carga
      $(this)
        .find("i.fal")
        .removeClass("fa-search")
        .addClass("fa-spinner fa-pulse");
      // Recarga la URL según la acción del formulario y los parámetros de búsqueda proporcionados
      const url = $(this)
        .closest("form")
        .attr("action");
      self.doSearch(url);
    });

    // Exportar registros
    $("#btn-exportar").click(function (e) {
      e.preventDefault();
      const url = $(this).attr("href");
      self.doSearch(url);
    });

    // Limpia los filtros de búsqueda
    $("#btn-limpiar").click(e => {
      e.preventDefault();
      $(".filter").each(function (i, el) {
        const type = $(el).prop("type");
        if (type === "checkbox" || type === "radio") {
          $(el).prop("checked", false);
        } else {
          $(el).val("");
        }
      });
      $(".select2")
        .val([])
        .trigger("change.select2");

      // Filtra nuevamente con los datos originales
      $("#btn-buscar").trigger("click");
    });
  },

  handleOrderBy() {
    $(".sorting").click(e => {
      const $target = $(e.target);
      const order = $target.data("order");
      let direction = $target.data("direction");

      direction = direction === "desc" ? "asc" : "desc";

      let params = FormHelper.getFilterParams();
      params.push(`order[${order}]=${direction}`);

      const url = $("form.js-filters-form").attr("action");
      window.location.href =
        url + (params.length > 0 ? "?" + params.join("&") : "");
    });
  },

  handleImports() {
    $(".js-btn-importar").click(e => {
      e.preventDefault();

      const $form = $($(e.currentTarget).parents("form"));
      const $inputFilters = $('input[name="filtros_actuales"]', $form);

      if ($inputFilters.length > 0) {
        const params = this.getFilterParams();
        $inputFilters.val(params.length > 0 ? params.join("&") : "");
      }

      $form.submit();
    });
  },

  doSearch(url) {
    // Obtiene los parámetros de búsqueda
    const params = this.getFilterParams();
    window.location.href =
      url + (params.length > 0 ? "?" + params.join("&") : "");
  },

  getFilterParams() {
    const params = [];

    $(".filter").each((index, obj) => {
      const type = $(obj).prop("type");
      if (
        (type === "checkbox" && $(obj).is(":checked")) ||
        ($(obj).val() && $(obj).val().length > 0 && type !== "checkbox")
      ) {
        params.push($(obj).attr("name") + "=" + $(obj).val());
      }
    });

    return params;
  },

  createLinkAndDownload(url, name) {
    const element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", name);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  },

  sendMail(to, cc, subject, message) {
    cc = cc || "";
    if (cc && cc.length > 0) {
      cc = "cc=" + cc + "&";
    }

    subject = encodeURIComponent(subject);

    //message = message.replaceAll('%0D%0A', '[[BR]]');
    message = message.replaceAll('&', encodeURIComponent('&'));
    //message = encodeURIComponent(message);
    //message = message.replaceAll('[[BR]]', '%0D%0A');

    const element = document.createElement("a");
    element.setAttribute(
      "href",
      `mailto:${to}?${cc}subject=${subject}&body=${message}`
    );

    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },

  confirm(form, mensaje) {
    if (Notificaciones !== undefined) {
      let params = {
        mensaje: mensaje,
        callback(result) {
          if (result) {
            form.submit();
          }
        }
      };
      Notificaciones.showBootbox("confirm", params);
    } else {
      console.error("API de Notificaciones no disponible.");
    }
  },

  dialog(options) {
    if (Notificaciones !== undefined) {
      Notificaciones.showBootbox("dialog", {options: options});
    } else {
      console.error("API de Notificaciones no disponible.");
    }
  },

  formatTime(str) {
    str = str.replace(':', '');

    if (str.length > 2) {
      str = ('0' + str).slice(-4);
    } else {
      str = ('0' + str + '00').slice(-4);
    }

    let mm = parseInt(str.substr(2, 2));
    let hh = parseInt(str.slice(0, 2));

    if (mm > 59) {
      mm = mm - 60;
    }

    if (hh > 23) {
      hh = hh % 24;
    }

    mm = ('0' + mm).slice(-2);
    hh = ('0' + hh).slice(-2);

    return hh + ':' + mm;
  }
};
